import { render, staticRenderFns } from "./bene-info.vue?vue&type=template&id=d39f83d8&"
import script from "./bene-info.vue?vue&type=script&lang=js&"
export * from "./bene-info.vue?vue&type=script&lang=js&"
import style0 from "./bene-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports